import React from 'react'

const SpecialOffers = () => {
  return (
    <div>SpecialOffers</div>
  )
}

export default SpecialOffers